import '../common/base';
import Vue from './common/vue-common';
import BrasilidadePage from './components/brasilidade/BrasilidadePage';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
new Vue(BrasilidadePage);
